import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_KEY;

if (!url || !key) {
  // 개발 편의: .env 누락 시 명확한 안내
  // eslint-disable-next-line no-console
  console.error('[루트] .env 의 REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_KEY 가 없습니다. .env.example 참고.');
}

export const supabase = createClient(url, key, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

// 회사 도메인 (가입/로그인 제한 안내용)
export const ALLOWED_DOMAIN = 'rhoonart.com';
